import { types } from 'mobx-state-tree';

export const Statistics = types.model('statistics', {
  discoveredItemsCount: types.maybe(types.number),
  failedBlackListCategoryCount: types.maybe(types.number),
  failedBlackListCount: types.maybe(types.number),
  failedItemsCount: types.maybe(types.number),
  failedVeroCount: types.maybe(types.number),
  itemsCount: types.maybe(types.number),
  itemsWithValidationFailed: types.maybe(types.number),
  filteredItemsCount: types.maybe(types.number),
});
